import { StyledCell } from 'components/base/Table/Table.styles';
import MenuButton, { MenuButtonItem } from 'components/MenuButton';

const OptionsCell = ({ token, onDelete, setPrimary }) => {
  const isPrimary = token?.is_primary;
  const isStateOK = token?.state === 'ok';

  return (
    <StyledCell>
      <MenuButton
        clickable
        buttonVariant='outline'
        width='10rem'
        items={[
          <MenuButtonItem
            key='delete-token'
            text={<div className='text-xs text-destructive'>Delete</div>}
            onClick={onDelete}
            disabled={isPrimary}
          />,
          <MenuButtonItem
            key='set-primary-token'
            text={<div className='text-xs'>Make primary</div>}
            onClick={setPrimary}
            disabled={!isStateOK || isPrimary}
          />
        ]}
      />
    </StyledCell>
  );
};

export default OptionsCell;
